import React from 'react';
import { Icon } from '../Icon';

export function SearchIcon(props: any) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <path
                id="magnifying_glass"
                d="M456.68,400.81l-94-95.51-19.8,20-31.2-31.64a146.28,146.28,0,0,0,31.56-90.85C343.25,123,279.23,58,200.54,58S57.83,123,57.83,202.85s64,144.85,142.71,144.85a141.38,141.38,0,0,0,95.24-36.93L326.55,342l-18.79,19,93.08,95.44a36.76,36.76,0,0,0,26.87,11.6h.47c12.4,0,23.23-5.32,28.57-10.71C466.39,447.1,476.27,420,456.68,400.81Zm-136.5-198c0,66.92-53.63,121.37-119.56,121.37S81.07,269.74,81.07,202.77,134.7,81.4,200.62,81.4,320.18,135.88,320.18,202.85ZM445,426.58c.23,6.38-3.92,12-5.39,13.49l0,0a16.51,16.51,0,0,1-22.35,0L339.31,361l22.5-23.61,77.74,78.95.17.16C443.07,419.39,444.83,422.78,445,426.58Z"
            />
        </Icon>
    );
}
